import {
    Directive,
    ElementRef,
    HostListener,
    OnInit,
    Optional,
  } from "@angular/core";
  import { NgModel, NgControl } from "@angular/forms";
//   import { G2ConfigService } from "src/app/g2-config/config.service";
  
  @Directive({
    selector: "[sanitized]",
  })
  export class G2SanitizedInputDirective implements OnInit {
    sanitizationRegex: RegExp = /[^a-zA-Z0-9 &,\-.@/_':]*/g;
    valueSubscription;
    constructor(
      private _el: ElementRef,
    //   private _configService: G2ConfigService,
      @Optional() public model: NgModel,
      @Optional() public ngControl: NgControl
    ) {}
  
    ngOnInit(): void {
      this.valueSubscription = this.ngControl.control.valueChanges.subscribe(
        (value) => {
          const newVal = this.transform(value);
          this.ngControl.control.setValue(newVal, { emitEvent: false });
        }
      );
    }
  
    @HostListener("input", ["$event"]) onInputChange(event) {
      event.target.value = this.transform(event.target.value);
      if (this.model) {
        this.model.update.emit(event.target.value);
      }
    }
  
    transform(input: string): string {
      return input.replace(this.sanitizationRegex, "");
    }
  }